const locale = {
	// #region Tabs
	TAB_LIST: 'Lista',
	TAB_DEFAULT_RECIPIENTS: 'Destinatari default',
	// #endregion

	// #region DEMs fields
	DETAILS_DEMS_FIELD_TITLE: 'Titolo',
	DETAILS_DEMS_FIELD_DATE: 'Data',
	DETAILS_DEMS_FIELD_MARKETINGACTION: 'Azione Marketing padre',
	DETAILS_DEMS_FIELD_ASSIGNED_USER: 'Utente assegnato',
	DETAILS_DEMS_FIELD_ASSIGNED_GROUP: 'Gruppo assegnato',
	DETAILS_DEMS_FIELD_WARNING: 'Warning',
	DETAILS_DEMS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_DEMS_FIELD_TAGS: 'Tag',
	// #endregion

	// #region DEMs filters
	DETAILS_DEMS_FIELD_STATUS: 'Stato DEM',
	DETAILS_DEMS_FIELD_OPEN_COUNT: 'N. aperture',
	DETAILS_DEMS_FIELD_CLICKS_COUNT: 'N. click',
	// #endregion

	DEMS_SETTINGS_DIALOG_TITLE: "Impostazioni dell'invio",
	DETAILS_DEMS_FIELD_SUBJECT: 'Oggetto',
	DETAILS_DEMS_FIELD_PREVIEWTEXT: 'Preview text',
	DETAILS_DEMS_FIELD_SENDER_NAME: 'Nome mittente',
	DETAILS_DEMS_FIELD_SENDER_SURNAME: 'Cognome mittente',
	DETAILS_DEMS_FIELD_SENDER_MAIL: 'Email mittente',
	DETAILS_DEMS_FIELD_DEFAULT_LANGUAGE: 'Lingua messaggio predefinita',

	DEMS_RECIPIENTS_COLUMN_MAIL: 'Indirizzo Mail',
	DEMS_RECIPIENTS_COLUMN_ITEM: 'Elemento collegato',
	DEMS_RECIPIENTS_COLUMN_DEM: 'DEM',
	DEMS_RECIPIENTS_COLUMN_STATUS: 'Stato DEM',
	DEMS_RECIPIENTS_COLUMN_DATE: 'Data',
	DEMS_RECIPIENTS_COLUMN_CLICKS: 'Click',
	DEMS_RECIPIENTS_COLUMN_OPENS: 'Aperture',
	DEMS_RECIPIENTS_COLUMN_UNSUBSCRIBED: 'Disiscritto',
	DEMS_RECIPIENTS_COLUMN_BOUNCE: 'Errore',

	DIALOG_TITLE_RECIPIENTS_OPEN_DETAILS: 'Dettagli aperture',
	DIALOG_TITLE_RECIPIENTS_CLICK_DETAILS: 'Dettagli Click',

	DEMS_RECIPIENTS_TABLE_FOOTER_COUNTERS: 'Aziende: {nCompanies} - Persone: {nPeople} - Utenti: {nUsers}',

	DEMS_URLS_COLUMN_LINK: 'Link',
	DEMS_URLS_COLUMN_CLICKS: 'Click',

	DEMS_MESSAGES_DIALOG_TITLE: 'Seleziona il messaggio da inviare',
	ALERT_MSG_OPEN_DEMS: "Errore durante l'operazione",

	DIALOG_OPEN_DEMS_TITLE: 'DEM Aperti',
	DIALOG_OPEN_DEMS_CONTENT: 'Per poter creare un nuovo DEM è necessario chiudere quelli esistenti.',

	// #region Details DEM Manager section
	DEMS_MANAGER_SECTION: 'Gestore DEM',
	DEMS_SELECT_CONNECTOR: 'Seleziona connettore',
	DEMS_SELECT_CONNECTOR_DESCRIPTION: '',
	DEMS_CONNECTOR_MAILUP: 'MailUp',
	DEMS_CONNECTOR_MAILCHIMP: 'MailChimp',
	DEMS_CONNECTOR_ERROR_NOT_LOGGED: 'Devi collegare il tuo account per caricare destinatari',
	DEMS_ADD_RECIPIENTS: 'Aggiungi Destinatari',
	DEMS_MAILUP_ADD_RECIPIENTS_DESCRIPTION:
		"Il primo passo per preparare un DEM è costruire il messaggio tramite l'editor di MailUp. Successivamente si può cominciare a preparare la lista dei destinatari manualmente oppure utilizzando le funzionalità qui presenti per inserire massivamente le Aziende e/o le Persone tramite filtri qua sotto presenti.",
	DEMS_MAILCHIMP_ADD_RECIPIENTS_DESCRIPTION:
		"Il primo passo per preparare un DEM è costruire il messaggio tramite l'editor di MailChimp. Successivamente si può cominciare a preparare la lista dei destinatari manualmente oppure utilizzando le funzionalità qui presenti per inserire massivamente le Aziende e/o le Persone tramite filtri qua sotto presenti.",
	DEMS_ACTION_BACK: 'Indietro',
	DEMS_UPLOAD_DEFAULT_RECIPIENTS: 'Carica destinatari di Default',
	DEMS_UPLOAD_RECIPIENTS: 'Carica',
	DEMS_SEND: 'Conferma invio',
	DEMS_MAILUP_SEND_DESCRIPTION:
		'Gli indirizzi email sono stati caricati su MailUp in un Audience ad hoc. Quando vuoi confermare l\'invio/schedulazione del DEM premi il bottone "Invia" oppure il bottone "Annulla" per tornare al passo precedente.',
	DEMS_MAILCHIMP_SEND_DESCRIPTION:
		'Gli indirizzi email sono stati caricati su MailChimp in un Audience ad hoc. Quando vuoi confermare l\'invio/schedulazione del DEM premi il bottone "Invia" oppure il bottone "Annulla" per tornare al passo precedente.',
	DEMS_ACTION_CANCELSEND: 'Annulla',
	DEMS_ACTION_SEND: 'Invia',
	DEMS_SENDING: 'Invio in corso',
	DEMS_SENDING_DESCRIPTION: 'Invio programmato il {date}',
	DEMS_ACTION_UNSCHEDULE: 'Annulla invio',
	DEMS_ACTION_CHECK_SEND_STATUS: 'Controlla stato',
	DEMS_DOWNLOAD_STATS: 'Scarica statistiche',
	DEMS_MAILUP_DOWNLOAD_STATS_DESCRIPTION:
		'MailUp ha cominciato la procedura di invio. Una volta completata sarà possibile aggiornare e sincronizzare le statistiche di questo DEM tramite la funzione "Scarica Statistiche". E\' possibile utilizzare questa funzionalità più volte, in modo da mantenere metriche sempre allineate con quelle disponibili tramite MailUp.',
	DEMS_MAILCHIMP_DOWNLOAD_STATS_DESCRIPTION:
		'MailChimp ha cominciato la procedura di invio. Una volta completata sarà possibile aggiornare e sincronizzare le statistiche di questo DEM tramite la funzione "Scarica Statistiche". E\' possibile utilizzare questa funzionalità più volte, in modo da mantenere metriche sempre allineate con quelle disponibili tramite MailChimp.',
	DEMS_DOWNLOAD: 'Scarica',
	DEMS_UPDATE_STATS: 'Aggiorna statistiche',
	DEMS_MAILCHIMP_DELETE_LIST: 'Elimina pubblico da MailChimp',
	// #endregion

	// #region Details Dem Statistics section
	DEMS_NO_STATS: 'Nessuna statistica',
	DEMS_STATISTICS_SECTION: 'Statistiche',
	DEMS_STATISTICS_TOTAL: 'Totale',
	DEMS_STATISTICS_SENT: 'Inviate',
	DEMS_STATISTICS_DELIVERED: 'Consegnate',
	DEMS_STATISTICS_OPENED: 'Aperte',
	DEMS_STATISTICS_CLICKED: 'Click univoci',
	DEMS_STATISTICS_UNSUBSCRIBED: 'Disiscritti',
	DEMS_STATISTICS_VALUE: 'Valore Offerte email marketing',
	DEMS_STATISTICS_REVENUE: 'Profitti email marketing',
	// #endregion

	// #region Details Dem Add Recipients section
	DEMS_SECTION_ADD_TITLE: 'Aggiungi alla lista',
	DEMS_SECTION_ADD_RECIPIENT: 'Aggiungi',
	DEMS_SECTION_ADD_COMPANY: 'Azienda',
	DEMS_SECTION_ADD_PERSON: 'Persona',
	DEMS_SECTION_ADD_ALL: 'Azienda + Persone',
	DEMS_SECTION_ADD_MAIL: 'Email',

	DEMS_SECTION_ADD_COMPANIES_TITLE: 'Aggiungi Aziende filtrate',
	DEMS_SECTION_ADD_PEOPLE_TITLE: 'Aggiungi Persone filtrate',
	DEMS_SECTION_ADD_MAILS_TITLE: 'Aggiungi Email filtrate',

	DEMS_SECTION_COPY_TITLE: 'Importa da',
	DEMS_SECTION_COPY_MARKETINGACTION: 'Azione di Marketing',
	DEMS_SECTION_COPY_DEM: 'DEM',
	DEMS_SECTION_COPY_COMMERCIALCAMPAIGN: 'Campagna Commerciale',
	DEMS_SECTION_COPY_INCLUDE_ASSOCIATED_PEOPLE: 'Includi anche gli indirizzi e-mail di tutte le persone collegate',

	DEMS_DIALOG_TITLE_ADD_RESULT: 'Vuoi aggiungere questi Indirizzi Mail?',
	// #endregion

	// #region Details MarketingAction Delete Rows section
	DEMS_SECTION_EMPTY_TITLE: 'Svuota la lista',
	DEMS_SECTION_EMPTY_DESCRIPTION:
		'Tramite questa funzione puoi svuotare tutta la lista (eliminando TUTTI gli elementi aggiunti)',
	DEMS_SECTION_EMPTY_BUTTON_CLEAR: 'Svuota',
	// #endregion

	// #region DEMs Bounce types
	DIALOG_INFO_SB_TITLE: 'Soft Bounce',
	DIALOG_INFO_SB_TEXT:
		'Questo è un errore generico, dato quando N:Bounce non è in grado di interpretare la risposta dal server, in quanto non è standard o equivoca.',
	DIALOG_INFO_HB_TITLE: 'Hard Bounce',
	DIALOG_INFO_HB_TEXT:
		'Questo messaggio ha avuto errori PERMANENTI durante la consegna. Questi, tipicamente, sono errori da indirizzi mail errati. Dopo una o più consegne fallite, il messaggio viene rimosso dalla coda di invio e il corrispettivo iscritto viene disiscritto.',
	DIALOG_INFO_SBDF_TITLE: 'Soft Bounce - DNS Faliure',
	DIALOG_INFO_SBDF_TEXT:
		"Problemi con il DNS. Il messaggio ha avuto errori di consegna PERMANENTI. È un errore dato dal fatto che il dominio del ricevente (host) non si è risolto in un equivalente IP valido. La causa potrebbe essere un problema temporaneo del server ricevente, o che l'indirizzo del dominio di destinazione non esiste o è stato scritto errato.",
	DIALOG_INFO_SBMF_TITLE: 'Soft Bounce - Mailbox Full',
	DIALOG_INFO_SBMF_TEXT:
		'La casella è piena. Questo messaggio non è stato consegnato perchè la casella del ricevente sta temporaneamente eccedendo la sua quota. Questi indirizzi devono esser rimossi dalla lista di Iscritti solo se il totale raggiunge un alto numero di errori, comparato al numero di consegne.',
	DIALOG_INFO_GB_TITLE: 'General Bounce',
	DIALOG_INFO_GB_TEXT:
		'Il messaggio include porzioni di testo non interpretabili. Il messaggio ha errori di consegna PERMANENTI. Dopo tre tentativi di consegna, il messaggio è stato rimosso dalla coda di invio.',
	DIALOG_INFO_MB_TITLE: 'Mail Block',
	DIALOG_INFO_MB_TEXT:
		"Il messaggio include porzioni di testo non interpretabili. Il messaggio ha errori di consegna PERMANENTI. Il server mail del ricevente ha rifiutato il messaggio per un motivo non specificato. Visualizza i dettagli dell'errore per aver più informazioni.",
	DIALOG_INFO_TB_TITLE: 'Transient Bounce',
	DIALOG_INFO_TB_TEXT:
		"Errore temporaneo: il sistema di consegna ha trovato un errore nel sistema del ricevente, ma riproverà nuovamente a consegnare. Se l'errore persiste, il sistema darà un errore 'Hard Bounce'.",
	DIALOG_INFO_MBRD_TITLE: 'Mail Block - Relay Denied',
	DIALOG_INFO_MBRD_TEXT:
		"Il messsaggio ha errori di consegna PERMANENTI. Il messaggio è stato bloccato dal sistema di ricezione del ricevente in quanto la connessione al server di invio è stata rifiutata. Solitamente accade quando il server SMTP non può esser rilevato o quando gli account non possono ricevere alcuna mail dall'esterno.",
	DIALOG_INFO_MBSD_TITLE: 'Mail Block - Spam Detected',
	DIALOG_INFO_MBSD_TEXT:
		'Il messaggio è stato classificato come Spam dal sistema mail del ricevente. Questi bounces sono meno seri degli altri, ma necessiti di monitorarli comunque in quanto non è un segnale incoraggiante. Solitamente, sono classificati come Spam da regole automatiche. Dovresti contattare il ricevente per provare a capire perchè il tuo messaggio è stato classificato come spam.',
	// #endregion

	// #region Default recipients tab
	DEMS_DEFAULT_RECIPIENTS_ADD_TITLE: 'Seleziona Mail',
	DEMS_DEFAULT_RECIPIENTS_ADD_BUTTON: 'Aggiungi destinatario'
	// #endregion
};

export default locale;
